<template>
	<div>
		<Listings
			v-if="soldListings"
			:listings="soldListings"
			orientation="horizontal"
			class="fade"
			:view="view"
		/>

		<div class="w-full flex justify-center items-center mt-90 pb-80">
			<a class="filled-button filled-button-red block cursor-pointer z-2" href="/listings?status=Closed&limit=12&brokers=70600&brokers=71581">
				<span class="filled-button-content">View More</span>
				<span class="button-arrow filled-button-arrow"></span>
			</a>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

import Listings from '../listings/listings.vue';

// Loads the sold residential listing group shown on /list.
export default {
	data() {
		return {
			soldListings: [],
			view: 'list',
		};
	},
	methods: {
		getListings() { 
			axios 
				.get(`https://api.simplyrets.com/properties?status=Closed&limit=12&brokers=70600&brokers=71581`, {
					auth: {
						username: 'dev_gkd161z1', //'dev_gkd161z1',
						password: '7331f601341j9871' //'7331f601341j9871'
					}
				})
				.then(response => {
					this.soldListings = response.data;

					if (this.soldListings.length) {
						var element = document.getElementById("sold-listings-container");
						if (element) element.classList.remove("hidden");
					}
				});
		},
	},
	created() {
		this.getListings();
	},
	components: {
		Listings
	}
};
</script>
